module.exports = __webpack_public_path__ + "img/character_leafe.d5e53880.png";